import React from 'react';
import { TextFieldProps } from '@mui/material';
import { StyledError, StyledInputContainer, StyledTextField } from './styles';

interface Props {
  value?: string;
  onChange?: any;
  error?: string;
  disableErrorMode?: boolean;
  maxWidth?: string;
  isHeader?: boolean;
  multiline?: boolean;
  rows?: number;
  maxLength ?: number
  label?: string;
  readonly?: boolean;
  autoHeight?: boolean;
  disabled ?: boolean;
  hide?: boolean;
  transformToUppercase?: boolean,
  onNestedFieldChange?: (value: string) => void;
}

const TextInput: React.FC<Props & TextFieldProps> = ({
  value,
  onChange,
  error,
  disableErrorMode,
  maxWidth,
  isHeader,
  multiline,
  rows,
  label,
  autoHeight,
  maxLength = null,
  disabled,
  transformToUppercase = false,
  onNestedFieldChange,
  hide,
  readonly,
  ...props
}) => (
  <StyledInputContainer
    autoHeight={autoHeight}
    isHeader={isHeader}
    maxWidth={maxWidth}
    hide={hide}
  >
    <StyledTextField
      {...props}
      multiline={multiline}
      rows={rows}
      value={value || ''}
      disabled={disabled || readonly}
      error={disableErrorMode ? undefined : !!error}
      onChange={(event) => {
        if (onChange) {
          const inputValue = event?.currentTarget?.value || '';
          const transformedValue = transformToUppercase ? inputValue.trim().toUpperCase() : inputValue;
          onChange(transformedValue);
        } else if (onNestedFieldChange) {
          const inputValue = event?.currentTarget?.value || '';
          const transformedValue = transformToUppercase ? inputValue.trim().toUpperCase() : inputValue;
          onNestedFieldChange(transformedValue);
        }
      }}
      // inputProps={{ maxLength: maxLength}}
      label={label}
    />
    {!disableErrorMode && error && (
      <StyledError variant='body2'>{error}</StyledError>
    )}
  </StyledInputContainer>
);

export default TextInput;